import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import {
  fetchSingleTrain,
  fetchSingleJrTrain,
  receiveSingleTrain,
  receiveSingleJrTrain,
  closeTrainModal,
} from '../actions'
import SingleTrainModal from '../components/train_positions/SingleTrainModal'
import { createCommonActionCreators } from './helpers/trainActionCreators'

const mapStateToProps = state => {
  const { trains, showingTrain, jrLocationUpdatedAt, jrDetailUpdatedAt } = state.trainPositionReducer
  const { themeName } = state.themeReducer

  return {
    trains,
    showingTrain,
    themeName,
    jrLocationUpdatedAt,
    jrDetailUpdatedAt,
  }
}

const mapDispatchToProps = dispatch => {
  const commonActions = createCommonActionCreators(dispatch)

  return {
    ...commonActions,
    fetchSingleTrain: async (train) => {
      try {
        const payload = await fetchSingleTrain(train.train_number)
        dispatch(receiveSingleTrain(payload, train))
      } catch (error) {
        console.log(error)
        showAlert('列車情報が取得できませんでした')
      }
    },
    fetchSingleJrTrain: async (train) => {
      try {
        const payload = await fetchSingleJrTrain(train.train_number)
        dispatch(receiveSingleJrTrain(payload, train))
      } catch (error) {
        showAlert('JR線列車情報が取得できませんでした')
      }
    },
    closeTrainModal: () => {
      dispatch(closeTrainModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleTrainModal)
